/** @format */

import { fromJS, Map } from 'immutable';

const INITIAL_STATE = fromJS({
  show: false,
  loading: false,
  data: Map(),
  folder: '',
  error: '',
  total: 0,
  count: 0
});

export default function downloadCsvFileReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SHOW_DOWNLOAD_CSV_FILE_MODAL': {
      return state
        .set('show', true)
        .set('loading', true)
        .set('count', 0)
        .set('total', 0)
        .set('folder', action.payload.folder);
    }
    case 'LOADING_DOWNLOAD_CSV_FILE_DATA': {
      return state
        .set('count', action.payload.count)
        .set('total', action.payload.total);
    }
    case 'LOADING_DOWNLOAD_CSV_FILE_DATA_DONE': {
      return state.set('loading', false).set('data', fromJS(action.payload));
    }
    case 'HIDE_DOWNLOAD_CSV_FILE_MODAL': {
      return INITIAL_STATE;
    }
    case 'LOADING_DOWNLOAD_CSV_FILE_DATA_FAILED': {
      return state.set('loading', false).set('error', action.payload.msg);
    }
    default: {
      return state;
    }
  }
}
